const arrowWidth = 4;

export default (theme) => ({
    root: {
        zIndex: 9999,
        '& .hoi-poi-tooltip-inner': {
            padding: '4px 8px',
            color: 'white',
            ...theme.typography.caption,
            textAlign: 'left',
            textDecoration: 'none',
            backgroundColor: theme.colors.actionMinor[550],
            borderRadius: '4px',
            overflowWrap: 'break-word',
        },
        '& .hoi-poi-tooltip-arrow': {
            position: 'absolute',
            width: 0,
            height: 0,
            borderColor: theme.colors.transparent,
            borderStyle: 'solid',
        },
        // Arrow styles for each placement - floating-ui handles positioning via inline styles
        '&.hoi-poi-tooltip-placement-top .hoi-poi-tooltip-arrow, &.hoi-poi-tooltip-placement-topLeft .hoi-poi-tooltip-arrow, &.hoi-poi-tooltip-placement-topRight .hoi-poi-tooltip-arrow':
            {
                borderWidth: `${arrowWidth}px ${arrowWidth}px 0`,
                borderTopColor: theme.colors.actionMinor[550],
            },
        '&.hoi-poi-tooltip-placement-right .hoi-poi-tooltip-arrow, &.hoi-poi-tooltip-placement-rightTop .hoi-poi-tooltip-arrow, &.hoi-poi-tooltip-placement-rightBottom .hoi-poi-tooltip-arrow':
            {
                borderWidth: `${arrowWidth}px ${arrowWidth}px ${arrowWidth}px 0`,
                borderRightColor: theme.colors.actionMinor[550],
            },
        '&.hoi-poi-tooltip-placement-left .hoi-poi-tooltip-arrow, &.hoi-poi-tooltip-placement-leftTop .hoi-poi-tooltip-arrow, &.hoi-poi-tooltip-placement-leftBottom .hoi-poi-tooltip-arrow':
            {
                borderWidth: `${arrowWidth}px 0 ${arrowWidth}px ${arrowWidth}px`,
                borderLeftColor: theme.colors.actionMinor[550],
            },
        '&.hoi-poi-tooltip-placement-bottom .hoi-poi-tooltip-arrow, &.hoi-poi-tooltip-placement-bottomLeft .hoi-poi-tooltip-arrow, &.hoi-poi-tooltip-placement-bottomRight .hoi-poi-tooltip-arrow':
            {
                borderWidth: `0 ${arrowWidth}px ${arrowWidth}px`,
                borderBottomColor: theme.colors.actionMinor[550],
            },
    },
});
